import { RDSChatroomList as RDSChatroomListComponent } from "@relay/rds/dist/index";
import React from "react";

interface Props {
  token: string;
  params: object;
  pollingMode: "get-mine" | "search-all";
  hideParticipants: boolean;
  onClickChatroom: (room) => void;
  selectFirstChatroomOnLoad: boolean;
  selectedChatroomKeyOverride?: string | null;
  chatroomFilter: ((chatroom) => boolean) | null;
}

const RDSChatroomList: React.FunctionComponent<Props> = (props: Props) => {
  return <RDSChatroomListComponent {...props} />;
};

export default RDSChatroomList;
